module.exports = __webpack_public_path__ + "static/media/cat-dureaza-sa-te-vindeci.16bc15d7.jpeg";